/**
 * Botón "Volver" unificado para todas las pantallas de la app.
 * Vuelve a la pantalla anterior del historial; si no hay historial
 * (p. ej. tras recargar), navega a `to` (por defecto el menú principal).
 */
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BackButtonProps {
  /** Ruta de respaldo si no hay pantalla anterior en el historial. */
  to?: string;
  label?: string;
  className?: string;
  variant?: "ghost" | "outline";
}

const BackButton = ({ to = "/hub", label = "Volver", className, variant = "outline" }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
    } else {
      navigate(to);
    }
  };

  return (
    <Button variant={variant} size="sm" onClick={handleBack} className={cn("gap-2", className)}>
      <ArrowLeft className="h-4 w-4" />
      {label}
    </Button>
  );
};

export default BackButton;
